export enum SkinTone {
  BROWN_0 = "BROWN_0",
  BROWN_1 = "BROWN_1",
  BROWN_2 = "BROWN_2",
  BROWN_3 = "BROWN_3",
  BROWN_4 = "BROWN_4",
  BROWN_5 = "BROWN_5",
  BROWN_6 = "BROWN_6",
  BROWN_7 = "BROWN_7",
  BROWN_8 = "BROWN_8",
  BROWN_9 = "BROWN_9",
  BLACK = "BLACK",
  GRAY = "GRAY",
  WHITE = "WHITE",
}

export enum CoverageLevel {
  MAXIMUM = "MAXIMUM",
  MINIMAL = "MINIMAL",
  MODERATE = "MODERATE",
}

export enum CoverageColor {
  BLACK = "BLACK",
  GRAY = "GRAY",
  WHITE = "WHITE",
}
